import type { TransformerExtended } from "@/Common/Models/Domain/Transformer";

import type { SuggestionItemApi } from "@/Modules/Agent/Models/Api";
import type { SuggestionItem } from "@/Modules/Agent/Models/Domain";

import { camel } from "@/Utils/Camelize";
import DefaultTransformerGenerator from "@/Common/Transformers/FunctionalBase";

const SuggestionTransformer: TransformerExtended<SuggestionItem, SuggestionItemApi> = {
  ...DefaultTransformerGenerator<SuggestionItem, SuggestionItemApi>(),

  toDomain(input: SuggestionItemApi) {
    return camel<SuggestionItemApi, SuggestionItem>(input);
  },
};

export type SuggestionTransformerType = TransformerExtended<SuggestionItem, SuggestionItemApi>;

export default SuggestionTransformer;
